const getLocale = (rootState) => rootState.ws.locale;

export default getLocale;
